module.exports = __webpack_public_path__ + "static/img/case_detail_17_4.4f9201e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_17_4.png
// module id = mf/6
// module chunks = 34